export default "__VITE_ASSET__16f3bc86__"